import React from 'react';

export const ArrowLeftIcon = ({
  width = 20,
  height = 20,
  color = 'currentColor',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.3188 18.3416H12.7021L20.8355 10.2083C21.4855 9.55831 21.4855 8.49165 20.8355 7.84165C20.5241 7.52956 20.1013 7.35417 19.6605 7.35417C19.2196 7.35417 18.7969 7.52956 18.4855 7.84165L7.50215 18.825C6.85215 19.475 6.85215 20.525 7.50215 21.175L18.4855 32.1583C19.1355 32.8083 20.1855 32.8083 20.8355 32.1583C21.4855 31.5083 21.4855 30.4583 20.8355 29.8083L12.7021 21.675H31.3188C32.2355 21.675 32.9855 20.925 32.9855 20.0083C32.9855 19.0916 32.2355 18.3416 31.3188 18.3416Z"
      fill={color}
    />
  </svg>
);
